import React from 'react';
import ReactDOM from 'react-dom/client';
import 'index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import App from 'App';
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from 'pages/queryClient';
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    
      <React.StrictMode>
        <QueryClientProvider client={queryClient}>
          
          <App />
        </QueryClientProvider>
      </React.StrictMode>
   
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
